// components/Checkout/bankTransfer.ts
export const bankDetails = {
  bank: 'Bank of Maldives (BML)',
  branch: 'Male Branch',
  accountName: 'VEHIDHI',
  accountNumber: '7770000140688',
  swiftCode: 'BMLMMVMV',
  iban: 'MV123456789012345678',
  reference: 'VEHIDHI-SHOP-REF-' + Date.now(),
};

export const copyToClipboard = (text: string) => {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(text);
  } else {
    // Fallback for older browsers
    const textArea = document.createElement('textarea');
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand('copy');
    document.body.removeChild(textArea);
  }
};